(function ($, window, document) {
    var $win = $(window);
    var $doc = $(document);

    console.log('hello');

    console.log('sup');

    function window_width() {
        var myWidth = 0;
        if (typeof window.innerWidth == "number") myWidth = window.innerWidth;
        else if (document.documentElement && document.documentElement.clientWidth)
            myWidth = document.documentElement.clientWidth;
        else if (document.body && document.body.clientWidth)
            myWidth = document.body.clientWidth;
        return myWidth;
    }

    function window_height() {
        var myHeight = 0;
        if (typeof window.innerHeight == "number") myHeight = window.innerHeight;
        else if (document.documentElement && document.documentElement.clientHeight)
            myHeight = document.documentElement.clientHeight;
        else if (document.body && document.body.clientHeight)
            myHeight = document.body.clientHeight;
        return myHeight;
    }

    function initSelect() {
        $('.gfield_select').selectric({
            disableOnMobile: false,
            nativeOnMobile: false,
        });
    }

    function initSlider() {
        $('.js-slider-fade').slick({
            dots: true,
            infinite: true,
            speed: 500,
            fade: true,
            autoplay: true,
            autoplaySpeed: 3500,
            cssEase: 'linear',
            arrows: false
        });
    }

    function clickHandlers() {
        $(".js-scroll").on('click', function(e){
            e.preventDefault();
            console.log($($(this).attr("href")))
            var position = $($(this).attr("href")).offset().top - $('.header').outerHeight();

            var body = $("html, body");
            body.stop().animate({
                scrollTop: position
            }, 500, 'linear', function(){});
        });
    }

    function footerFix() {
        var footerHeight = $('.footer').outerHeight();
        $('body').css('paddingBottom', footerHeight);
    }

    $win.on('load resize scroll', function(){
        if ($win.scrollTop() > 10) {
            $('.header').addClass('active')
        } else {
            $('.header').removeClass('active')
        }
        footerFix()
        let vh = $win.innerHeight() * 0.01;
        document.documentElement.style.setProperty('--vh', vh + "px");
    }).on('load',function(){
        initSelect()
        initSlider()
        clickHandlers()
    })

})(jQuery, window, document);